import { useState, useEffect } from "react";
import CourtsList from "./courts/courtsList";
import Games from "./games/games";
import { saveSportsData } from "../../store/slice/sportsSlice";
import { fetchSports } from "../../api/endpoint";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import Loader from "../../components/loader";

const Courts = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("Courts");
  const [loading, setLoading] = useState(false);
  const { auth } = useSelector((state) => state.login);

  useEffect(() => {
    const fetchSportsList = async () => {
      try {
        setLoading(true);
        const response = await axios.get(fetchSports, {
          headers: {
            Authorization: `Bearer ${auth}`,
          },
        });
        dispatch(saveSportsData(response?.data?.sports));
      } catch (error) {
        console.error("Error fetching sports:", error);
        // toast.error("Failed to load sports.");
      } finally {
        setLoading(false);
      }
    };
    fetchSportsList();
  }, [auth]);

  return (
    <>
      {loading && <Loader />}
      <div className="px-md-2 px-1 py-md-2 py-1">
        {/* <h2>Courts</h2> */}
        <ul className="nav nav-tabs">
          <li className="nav-item" style={{ cursor: "pointer" }}>
            <a
              className={`nav-link ${activeTab === "Courts" ? "active" : ""}`}
              onClick={() => setActiveTab("Courts")}
              style={{
                color: activeTab !== "Courts" ? "#2c3e50" : "",
                fontWeight: activeTab == "Courts" ? "600" : "normal",
                fontSize: activeTab == "Courts" ? "large" : "medium",
              }}
            >
              Courts
            </a>
          </li>
          <li className="nav-item" style={{ cursor: "pointer" }}>
            <a
              className={`nav-link ${activeTab === "Games" ? "active" : ""}`}
              onClick={() => setActiveTab("Games")}
              style={{
                color: activeTab !== "Games" ? "#2c3e50" : "",
                fontWeight: activeTab == "Games" ? "600" : "normal",
                fontSize: activeTab == "Games" ? "large" : "medium",
              }}
            >
              Games
            </a>
          </li>
        </ul>
        {activeTab === "Courts" && <CourtsList />}
        {activeTab === "Games" && <Games />}
      </div>
    </>
  );
};

export default Courts;
